<template>
  <el-form
    class="login-form"
    status-icon
    :rules="loginRules"
    ref="loginForm"
    :model="loginForm"
    label-width="0"
  >
    <div class="title" :style="textColor">登录</div>
    <!-- talent -->
    <el-form-item v-if="tenantMode" prop="tenantId">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        v-model="loginForm.tenantId"
        auto-complete="off"
        :placeholder="$t('login.tenantId')"
      >
        <i slot="prefix" class="icon-quanxian" />
      </el-input>
    </el-form-item>
    <el-form-item prop="username" style="margin:30px 0">
      <el-input
        size="small"
        id="username_123"
        v-model="loginForm.username"
        auto-complete="off"
        :placeholder="$t('login.username')"
      >
        <i slot="prefix" size="large" class="icon-yonghu" />
      </el-input>
    </el-form-item>
    <el-form-item prop="password"  style="margin:30px 0">
      <el-input
        id="password_123"
        size="small"
        :type="passwordType"
        v-model="loginForm.password"
        auto-complete="off"
        :placeholder="$t('login.password')"
      >
        <i
          class="el-icon-view el-input__icon"
          slot="suffix"
          size="large"
          @click="showPassword"
        />
        <i slot="prefix" size="large" class="icon-mima" />
      </el-input>
    </el-form-item>
    <!-- 验证码: -->
    <el-form-item v-if="this.website.captchaMode" prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            size="small"
            @keyup.enter.native="handleLogin"
            v-model="loginForm.code"
            auto-complete="off"
            :placeholder="$t('login.code')"
          >
            <i slot="prefix" class="icon-yanzhengma" />
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img
              :src="loginForm.image"
              class="login-code-img"
              @click="refreshCode"
            />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <button
        size="small"
        @click.prevent="handleLogin"
        :class="textColorButton"
        >{{ $t("login.submit") }}
      </button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { info } from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";
import { getTopUrl } from "@/util/util";
import userLogin2Vue from './userLogin2.vue';
import urlSettings from '@/config/url-settings.js';
export default {
  name: "userlogin",
  data() {
    return {
      tenantMode: this.website.tenantMode,
      textColor:'color:#f99d35',
      textColorButton:'login-submit123',
      loginForm: {
        //租户ID
        tenantId: "",
        //用户名
        username: "admin",
        //密码
        password: "admin",
        //账号类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image:
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      loginRules: {
        tenantId: [
          { required: false, message: "请输入租户ID", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 1, message: "密码长度最少为6位", trigger: "blur" },
        ],
      },
      passwordType: "password",
    };
  },
  created() {

    if(urlSettings.VUE_APP_ENV_NAME.indexOf('demo') > -1){
         this.textColor = 'color:#00D499';
        this.textColorButton = 'login-submit123'
     }else{
       if(urlSettings.VUE_APP_PROJECT_NAME=='crmedical' || urlSettings.VUE_APP_PROJECT_NAME=='winsyun'){
          this.textColor = 'color:#f99d35';
          this.textColorButton = 'login-submit'
       }else if(urlSettings.VUE_APP_PROJECT_NAME=='v4ward'){
          this.textColor = 'color:#00D499';
          this.textColorButton = 'login-submit123'
       }else{
         this.textColor = 'color:#00D499';
          this.textColorButton = 'login-submit123'
       }

     }

  },
  mounted() {
    this.getTenant();
    this.refreshCode();
    setTimeout(()=>{
      this.loginForm.username = '';
      this.loginForm.password = '';

    })
  },
  computed: {
    ...mapGetters(["tagWel"]),
  },
  props: [],
  methods: {
    refreshCode() {
      getCaptcha().then((res) => {
        const data = res.data;
        this.loginForm.key = data.key;
        this.loginForm.image = data.image;
      });
    },
    showPassword() {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    handleLogin(e) {
      console.log('e==>',e);
      e.preventDefault();
      console.log('==>',);
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "登录中,请稍后。。。",
            spinner: "el-icon-loading",
          });
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.tagWel.value });
              loading.close();
            })
            .catch(() => {
              loading.close();
              this.refreshCode();
            });
        }
      });
      e.preventDefault();
    },
    getTenant() {
      let domain = getTopUrl();
      if(urlSettings.TENANTID){
        this.tenantMode = false;
        this.loginForm.tenantId = urlSettings.TENANTID;
      }else{
        this.$message.error(`该域名【${domain}】未配置，请尽快联系管理员！`);
      }

    },
  },
};
</script>

<style lang='scss' scoped>
.login-form {
  padding: 50px 55px 0;
}
.title {
  text-align: center;
  color: #f99d35;
  font-size: 30px;
  letter-spacing: 5px;
  margin-bottom: 10px;
}
#username_123 {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
}
#password_123 {
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #ccc;
  font-size: 16px;

}
.login-submit{
  width: 100%;
  border: 1px solid #f99d35;
  color: #fff;
  background: linear-gradient(to right,#ffb768,#f99d35);
  height: 40px;
  border-radius: 2px;
  margin: 20px 0 50px 0;
  letter-spacing: 5px;
  font-size: 22px;
}
.login-submit123{
  width: 100%;
  border: 1px solid #00D499;
  color: #00D499;
  // background: linear-gradient(to right,#ffb768,#f99d35);
  background-color: #fff;
  height: 40px;
  border-radius: 2px;
  margin: 20px 0 50px 0;
  letter-spacing: 5px;
  font-size: 22px;
}
</style>
